import { Dispatch, Middleware } from 'redux';

import { _window } from '@/utils/ssr-window';

import { calendarNavigationKey, CalendarNavigationState } from './calendar-navigation.actions';
import { NavigationStored } from './calendar-navigation.types';

export const calendarNavigationStorageMw: Middleware<Dispatch, { [calendarNavigationKey]: CalendarNavigationState }> =
    (api) => (next) => (action) => {
        const result = next(action);
        const newValue = api.getState()[calendarNavigationKey];
        const stored = {
            rulerDateRange: newValue.rulerDateRange,
        } satisfies NavigationStored;
        _window?.localStorage?.setItem(calendarNavigationKey, JSON.stringify(stored));
        return result;
    };
